import { cn } from '@mint-lib/tw-utils';

import type {
  FileSystemNode,
  FolderNode,
} from '../../../../types/fileSystem.js';
import { FolderDraft } from './FolderDraft.jsx';
import { FolderItem } from './FolderItem.jsx';

type Props = {
  folders: FolderNode[];
  selectedFolderIds: string[];
  onToggleFolder: (id: string) => void;
  onOpenFolder: (folder: FolderNode) => void;
  isDrafting: boolean;
  onCommitDraft: (name: string) => boolean;
  onCancelDraft: () => void;
  renamingFolderId: string | null;
  onStartRename: (id: string) => void;
  onDeleteFolder: (folder: FolderNode) => void;
  onCommitRename: (id: string, name: string) => boolean;
  onCancelRename: () => void;
  onOpenMoveDialog: (nodes: FileSystemNode[]) => void;
  validateName: (name: string, excludeId?: string) => boolean;
  className?: string;
};

const FolderSection = ({
  folders,
  selectedFolderIds,
  onToggleFolder,
  onOpenFolder,
  isDrafting,
  onCommitDraft,
  onCancelDraft,
  renamingFolderId,
  onStartRename,
  onDeleteFolder,
  onCommitRename,
  onCancelRename,
  onOpenMoveDialog,
  validateName,
  className,
}: Props) => {
  if (!isDrafting && !folders.length) return null;

  return (
    <div
      className={cn(
        'max-h-48 shrink-0 gap-2 overflow-y-auto',
        className ?? 'flex flex-col',
      )}
      data-testid="folder-section"
    >
      {isDrafting && (
        <FolderDraft
          onCommit={onCommitDraft}
          onCancel={onCancelDraft}
          validateName={validateName}
        />
      )}

      {folders.map((folder) =>
        renamingFolderId === folder.id ? (
          <FolderDraft
            key={folder.id}
            initialValue={folder.name}
            onCommit={(name) => onCommitRename(folder.id, name)}
            onCancel={onCancelRename}
            validateName={(name) => validateName(name, folder.id)}
          />
        ) : (
          <FolderItem
            key={folder.id}
            folder={folder}
            isSelected={selectedFolderIds.includes(folder.id)}
            onToggleSelect={onToggleFolder}
            onOpen={onOpenFolder}
            onRename={onStartRename}
            onDelete={onDeleteFolder}
            onMove={onOpenMoveDialog}
          />
        ),
      )}
    </div>
  );
};

export { FolderSection };
